import { Component, forwardRef, Input, ViewChild, ElementRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseInputDirective } from '../base-input/base-input.directive';

@Component({
  selector: 'lib-gung-color-input',
  templateUrl: './gung-color-input.component.html',
  styleUrls: ['./gung-color-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => GungColorInputComponent),
      multi: true
    }
  ],
  standalone: false
})
export class GungColorInputComponent extends BaseInputDirective<string> {
  @Input()
  public extraInputClass = '';

  @Input()
  public labelBold = false;

  @Input()
  public footnote = false;

  @Input()
  public extraFormClass = '';

  @ViewChild('colorPicker', { static: false })
  colorPicker: ElementRef<HTMLInputElement>;

  public invalidColor = false;

  openColorPicker() {
    if (!this.disabled && !this.renderStatic) {
      this.colorPicker?.nativeElement?.click();
    }
  }

  onColorChange(event: Event) {
    const input = event.target as HTMLInputElement;
    this.value = input.value;
    this.validateColor(input.value);
  }

  onTextChange(event: Event) {
    const input = event.target as HTMLInputElement;
    this.value = input.value;
    this.validateColor(input.value);
  }

  private validateColor(color: string): void {
    if (!color) {
      this.invalidColor = false;
      return;
    }

    // Check for valid hex color format (#RGB, #RRGGBB, #RRGGBBAA)
    const hexRegex = /^#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/;
    
    this.invalidColor = !hexRegex.test(color);
  }
}
